<template>
    <div>
        <article class="message">
            <div class="message-body message-border-color-5">
                <p class="is-size-5-custom is-vertical-center min-text-height"
                   :class="{ 'has-text-left': this.isMobile && !this.isTablet, 'has-text-centered add-horizontal-center': !this.isMobile || this.isTablet }">
                    {{ $t('kmso.project_management.expertise_summary_4_text') }}
                </p>
            </div>
        </article>
    </div>
</template>

<script>
    export default {
        name: 'Projektmanagement-Fazit-5-4',
        props: [
            'isMobile',
            'isTablet',
        ],
    }
</script>
